import { SPColor } from "../../constants/color";

export const useStyles = {
  miniCard: {
    minWidth: { md: "180px", xs: "27%" },
    height: "100px",
    borderRadius: "10px",
    border: `solid 1px ${SPColor.DARK_BLUE}`,
  },
};
